module.exports = __webpack_public_path__ + "img/hxz_right.d621485c.png";